import { render } from "./BattlesOverview.vue?vue&type=template&id=553c0b34&scoped=true"
import script from "./BattlesOverview.vue?vue&type=script&lang=js"
export * from "./BattlesOverview.vue?vue&type=script&lang=js"

import "./BattlesOverview.vue?vue&type=style&index=0&id=553c0b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553c0b34"]])

export default __exports__